import React from 'react';
import { ActivityIndicator, StyleSheet, View } from 'react-native';

// Theme preferences and appearance are still hydrating. Keep this independent
// of both so the first themed screen always uses the saved appearance.
export default function AppLoadingFallback() {
  return (
    <View accessible accessibilityRole="progressbar" accessibilityLabel="Loading your care plan" accessibilityState={{ busy: true }} style={styles.root}>
      <ActivityIndicator size="large" color="#777777" />
    </View>
  );
}

const styles = StyleSheet.create({
  root: { flex: 1, alignItems: 'center', justifyContent: 'center' },
});
